import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import Modal from '../../UI/Modal';
import Textarea from '../../UI/Textarea';
import IconPen from '../../UI/Icons/IconPen';

import productActions from '../../../store/actions/productActions';
import helpers from '../../../helpers/helpers';

const ModalReportProduct = ({ productId, token }) => {
  const dispatch = useDispatch();
  const { complaintStatus, isLoading } = useSelector((state) => state.products);
  const [text_, setText] = useState(null);
  const [authorName, setAuthorName] = useState(null);

  const { getTranslationText } = helpers;

  const handleSendMessage = () => {
    const params = {
      product_id: productId,
      text: text_,
    };
    if (text_) {
      if (token) {
        dispatch(productActions.sendProductComplaint(params, token));
        setText(null);
      } else if (authorName) {
        params.author = authorName;
        dispatch(productActions.sendProductComplaint(params));
        setAuthorName(null);
        setText(null);
      } else {
        NotificationManager.error('Please, put your nickname');
      }
    } else {
      NotificationManager.error('Please, write something');
    }
  };

  const textChangeHandler = (e) => {
    setText(e.target.value);
  };
  const nameChangeHandler = (e) => {
    setAuthorName(e.target.value);
  };

  return (
    <Modal
      className="product__modal-report-product"
      modalTitle="Report product"
      modalTrigger={(
        <div className="product__data__controls__line red">
          <span><IconPen color="red" /></span>
          <p>{getTranslationText('product.report')}</p>
        </div>
      )}
      onSubmitLabel="Send"
      onSubmit={handleSendMessage}
      sendSuccess={complaintStatus}
      buttonDisabled={isLoading}
    >
      {token ? null : (
        <div className="form-field input_name">
          <label>Ваше имя</label>
          <input
            onChange={nameChangeHandler}
          />
        </div>
      )}
      <Textarea label="Report message" name="reportMessage" onChange={textChangeHandler} />
    </Modal>
  );
};

export default ModalReportProduct;
